// extracted by mini-css-extract-plugin
export default {"notfoundSection":"notfound_notfoundSection__TAUs4","link":"notfound_link__cO64+"};